export const useCaseRegistry = {

/* =================================================
   QSR / FAST FOOD
================================================= */

"canteen-monitoring":{
  category:"QSR",
  pages:["dashboard","camera","analytics","report","insights"],
  widgets:{
    dashboard:["live-count","table-occupancy","occupied-table-count",
      "available-table-count",
      "staff-utilization",
      "mobile-usage-alerts",
      "peak-hour",
      "status-indicator"],
    camera:["live-camera-grid","zone-heatmap"],
    report:["trend-graph","incident-table","table-usage-report","mobile-usage-report","occupancy-history"],
    analytics:["hourly-activity-graph","zone-comparison-chart","table-usage-report","mobile-usage-report","occupancy-history"],
    insights:["ai-insights","optimization-suggestions"]
  },
  modules:[
    "table-occupancy-detection",
    "person-counting",
    "mobile-phone-detection"
  ]
},

"employee-productivity":{
  category:"QSR",
  pages:["dashboard","camera","report","analytics","insights"],
  widgets:{
    dashboard:["live-count","staff-utilization","avg-dwell-time","productivity-score"],
    report:["trend-graph","shift-performance"],
    analytics:["zone-comparison-chart","hourly-activity-graph"],
    insights:["ai-insights","optimization-suggestions"]
  },
  modules:[
    "staff-idle-detection",
    "service-speed-analysis",
    "staff-density-analysis",
    "worker-posture-analysis"
  ]
},

"food-safety-hygiene":{
  category:"QSR",
  pages:["dashboard","camera","alert","compliance","insights"],
  widgets:{
    dashboard:["violation-count","compliance-score","risk-score"],
    alert:["alert-list","alert-severity-breakdown"],
    compliance:["violation-count","compliance-trend"],
    insights:["ai-insights","risk-analysis"]
  },
  modules:[
    "food-handling-detection",
    "surface-cleanliness",
    "glove-detection",
    "hairnet-detection"
  ]
},

"customer-wait-times":{
  category:"QSR",
  pages:["dashboard","camera","report","analytics","insights"],
  widgets:{
    dashboard:["queue-length","avg-dwell-time","queue-abandon-rate","peak-hour"],
    report:["trend-graph","queue-time-distribution"],
    analytics:["shift-performance","customer-flow-sankey"],
    insights:["ai-insights"]
  },
  modules:[
    "queue-detection",
    "service-time-analysis",
    "customer-behavior-analysis"
  ]
},

"staff-ppe-compliance":{
  category:"QSR",
  pages:["dashboard","camera","alert","compliance"],
  widgets:{
    dashboard:["violation-count","compliance-score"],
    alert:["alert-list","alert-severity-breakdown"],
    compliance:["violation-count","compliance-trend"]
  },
  modules:[
    "glove-detection",
    "hairnet-detection",
    "mask-detection"
  ]
},

"inventory-wastage":{
  category:"QSR",
  pages:["dashboard","camera","report","analytics","insights"],
  widgets:{
    dashboard:["wastage-rate","status-indicator"],
    report:["trend-graph"],
    analytics:["shift-performance","zone-comparison-chart"],
    insights:["ai-insights","optimization-suggestions"]
  },
  modules:[
    "portion-monitoring",
    "food-waste-detection"
  ]
},

"shift-scheduling":{
  category:"QSR",
  pages:["dashboard","camera","analytics","report"],
  widgets:{
    dashboard:["live-count","staff-utilization"],
    analytics:["shift-performance","hourly-activity-graph"],
    report:["trend-graph"]
  },
  modules:[
    "staff-density-analysis",
    "shift-pattern-analysis"
  ]
},

"cash-pos-reconciliation":{
  category:"QSR",
  pages:["dashboard","camera","report","alert"],
  widgets:{
    dashboard:["status-indicator","anomaly-rate"],
    report:["trend-graph","incident-table"],
    alert:["alert-list"]
  },
  modules:[
    "pos-anomaly-detection"
  ]
},

/* =================================================
   MANUFACTURING
================================================= */

"ppe-compliance":{
  category:"Manufacturing",
  pages:["dashboard","camera","alert","compliance","analytics"],
  widgets:{
    dashboard:["violation-count","compliance-score"],
    alert:["alert-list","alert-severity-breakdown"],
    compliance:["violation-count","compliance-trend"],
    analytics:["zone-comparison-chart"]
  },
  modules:[
    "helmet-detection",
    "glove-detection",
    "safety-vest-detection"
  ]
},

"line-productivity":{
  category:"Manufacturing",
  pages:["dashboard","camera","analytics","report","insights"],
  widgets:{
    dashboard:["throughput-rate","machine-utilization"],
    analytics:["trend-graph","shift-performance"],
    report:["trend-graph","incident-table"],
    insights:["ai-insights","optimization-suggestions"]
  },
  modules:[
    "machine-idle-detection",
    "production-line-analysis"
  ]
},

"quality-defect":{
  category:"Manufacturing",
  pages:["dashboard","camera","alert","analytics"],
  widgets:{
    dashboard:["defect-rate","violation-count"],
    alert:["alert-list"],
    analytics:["defect-distribution","trend-graph"]
  },
  modules:[
    "defect-detection",
    "product-quality-analysis"
  ]
},

"unauthorised-zone":{
  category:"Manufacturing",
  pages:["dashboard","camera","alert","analytics"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list","alert-timeline"],
    analytics:["zone-comparison-chart"]
  },
  modules:[
    "zone-intrusion-detection",
    "restricted-area-monitoring"
  ]
},

"equipment-anomaly":{
  category:"Manufacturing",
  pages:["dashboard","camera","alert","maintenance","analytics"],
  widgets:{
    dashboard:["status-indicator","machine-health-score"],
    alert:["alert-list"],
    maintenance:["maintenance-status","machine-health-table"],
    analytics:["anomaly-trend"]
  },
  modules:[
    "machine-anomaly-detection",
    "predictive-maintenance"
  ]
},

"ergonomics-fatigue":{
  category:"Manufacturing",
  pages:["dashboard","camera","alert","analytics"],
  widgets:{
    dashboard:["fatigue-score","risk-score"],
    alert:["alert-list"],
    analytics:["trend-graph"]
  },
  modules:[
    "worker-fatigue-detection",
    "worker-posture-analysis"
  ]
},

"visitor-management":{
  category:"Manufacturing",
  pages:["dashboard","camera","alert","report"],
  widgets:{
    dashboard:["live-count","visitor-count"],
    alert:["alert-list"],
    report:["visitor-log-table"]
  },
  modules:[
    "visitor-detection",
    "visitor-tracking"
  ]
},

/* =================================================
   HEALTHCARE
================================================= */

"hand-hygiene":{
  category:"Healthcare",
  pages:["dashboard","camera","compliance","analytics"],
  widgets:{
    dashboard:["violation-count","compliance-score"],
    compliance:["violation-count","compliance-trend"],
    analytics:["trend-graph"]
  },
  modules:[
    "hand-sanitization-detection"
  ]
},

"patient-fall":{
  category:"Healthcare",
  pages:["dashboard","camera","alert","report"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list"],
    report:["incident-table"]
  },
  modules:[
    "patient-fall-detection",
    "slip-fall-detection"
  ]
},

"ppe-gowning":{
  category:"Healthcare",
  pages:["dashboard","camera","compliance"],
  widgets:{
    dashboard:["violation-count","compliance-score"],
    compliance:["violation-count","compliance-trend"]
  },
  modules:[
    "mask-detection",
    "gown-detection"
  ]
},

"restricted-area":{
  category:"Healthcare",
  pages:["dashboard","camera","alert"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list"]
  },
  modules:[
    "restricted-zone-access"
  ]
},

"waiting-room":{
  category:"Healthcare",
  pages:["dashboard","camera","report","analytics"],
  widgets:{
    dashboard:["queue-length","avg-dwell-time"],
    report:["trend-graph"],
    analytics:["hourly-activity-graph"]
  },
  modules:[
    "queue-monitoring"
  ]
},

"asset-tracking":{
  category:"Healthcare",
  pages:["dashboard","camera","analytics","report"],
  widgets:{
    dashboard:["live-count","asset-utilization"],
    analytics:["trend-graph"],
    report:["asset-log-table"]
  },
  modules:[
    "asset-tracking"
  ]
},

"duress-detection":{
  category:"Healthcare",
  pages:["dashboard","camera","alert"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list"]
  },
  modules:[
    "aggression-detection",
    "violence-detection"
  ]
},

/* =================================================
   RETAIL
================================================= */

"footfall-heatmap":{
  category:"Retail",
  pages:["dashboard","camera","report","heatmap","analytics","insights"],
  widgets:{
    dashboard:["live-occupancy","avg-dwell-time","peak-hour"],
    report:["trend-graph"],
    heatmap:["zone-breakdown","heatmap-timeline"],
    analytics:["customer-flow-sankey","trend-graph"],
    insights:["ai-insights"]
  },
  modules:[
    "customer-counting",
    "heatmap-generation",
    "customer-path-analysis"
  ]
},

"queue-management":{
  category:"Retail",
  pages:["dashboard","camera","alert","analytics"],
  widgets:{
    dashboard:["queue-length","avg-dwell-time"],
    alert:["alert-list"],
    analytics:["queue-time-distribution"]
  },
  modules:[
    "queue-detection"
  ]
},

"theft-prevention":{
  category:"Retail",
  pages:["dashboard","camera","alert","analytics"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list"],
    analytics:["incident-distribution"]
  },
  modules:[
    "theft-detection",
    "loitering-detection",
    "object-left-behind"
  ]
},

"planogram":{
  category:"Retail",
  pages:["dashboard","camera","analytics","report"],
  widgets:{
    dashboard:["status-indicator"],
    analytics:["trend-graph"],
    report:["shelf-status-table"]
  },
  modules:[
    "shelf-monitoring"
  ]
},

"staff-deployment":{
  category:"Retail",
  pages:["dashboard","camera","analytics","report"],
  widgets:{
    dashboard:["live-count","staff-utilization"],
    analytics:["shift-performance"],
    report:["staff-performance-table"]
  },
  modules:[
    "staff-density-analysis"
  ]
},

"parking-occupancy-monitoring":{
  category:"Parking",
  pages:["dashboard","camera","alert","report","heatmap"],
  widgets:{
    dashboard:[
      "available-slots",
      "occupied-slots",
      "parking-utilisation",
      "occupancy-score",

      // ➕ Added
      "peak-hour",
      "risk-score",
      "trend-graph",
      "zone-breakdown"
    ],
    alert:["alert-list"],
    report:[
      "trend-graph",
      "occupancy-table",

      // ➕ Added
      "incident-distribution"
    ],
    heatmap:[
      "zone-breakdown",
      "heatmap-timeline",

      // ➕ Added
      "zone-comparison-chart"
    ]
  },
  modules:[
    "slot-detection",
    "occupancy-tracking",
    "zone-wise-analysis"
  ]
},

"vehicle-counting":{
  category:"Parking",
  pages:["dashboard","camera","alert","report"],
  widgets:{
    dashboard:[
      "vehicle-entry-count",
      "vehicle-exit-count",
      "current-vehicle-count",
      "traffic-load",

      // ➕ Added
      "throughput-rate",
      "trend-graph",
      "peak-hour"
    ],
    alert:["alert-list"],
    report:[
      "trend-graph",
      "vehicle-log",

      // ➕ Added
      "incident-distribution",
      "vehicle-log-table"
    ]
  },
  modules:[
    "vehicle-detection",
    "entry-exit-counting",
    "traffic-analysis"
  ]
},

"illegal-parking-detection":{
  category:"Parking",
  pages:["dashboard","camera","alert","report"],
  widgets:{
    dashboard:[
      "illegal-parking-count",
      "violation-zones",
      "risk-score",

      // ➕ Added
      "total-alerts",
      "incident-distribution",
      "anomaly-rate"
    ],
    alert:["alert-list"],
    report:[
      "incident-distribution",
      "violation-log",

      // ➕ Added
      "trend-graph",
      "incident-table"
    ]
  },
  modules:[
    "illegal-parking-detection",
    "zone-restriction-monitoring",
    "violation-alerting"
  ]
},

"parking-duration-tracking":{
  category:"Parking",
  pages:["dashboard","camera","alert","report"],
  widgets:{
    dashboard:[
      "avg-parking-duration",
      "overstay-vehicles",
      "duration-distribution",

      // ➕ Added
      "peak-hour",
      "risk-score",
      "trend-graph"
    ],
    alert:["alert-list"],
    report:[
      "duration-trend",
      "overstay-report",

      // ➕ Added
      "incident-distribution",
      "trend-graph"
    ]
  },
  modules:[
    "vehicle-tracking",
    "duration-calculation",
    "overstay-detection"
  ]
},

/* =================================================
   EDUCATION
================================================= */

"staff-gate-attendance":{
  category:"Education",

  pages:[
    "dashboard",
    "camera",
    "attendance-logs",
    "staff-summary",
    "report"
  ],

 widgets:{
    dashboard:[
      "staff-entry-count",
      "staff-exit-count",
      "staff-inside-count",
      "late-staff-count",
      "early-exit-count",
      "active-cameras"
    ],

    "attendance-logs":[
      "gate-entry-exit-log",
      "late-staff-table"
    ],

    "staff-summary":[
      "staff-entry-exit-summary",
      "staff-working-hours-table",
      "most-active-staff",
      "least-active-staff"
    ],

    report:[
      "staff-attendance-trend",
      "hourly-entry-trend",
      "hourly-exit-trend",
      "weekly-attendance-trend"
    ]
  },

  modules:[
    "teacher-entry-detection",
    "teacher-exit-detection",
    "gate-entry-exit-logging",
    "attendance-report-generation"
  ]
},

"student-classroom-counting":{
  category:"Education",

  pages:[
    "dashboard",
    "camera",
    "analytics",
    "report"
  ],

  widgets:{
    dashboard:[
      "live-count",
      "classroom-occupancy",
      "peak-hour"
    ],

    analytics:[
      "hourly-activity-graph",
      "zone-comparison-chart"
    ],

    report:[
      "attendance-trend"
    ]
  },

  modules:[
    "student-counting",
    "classroom-occupancy-detection",
    "attendance-analytics"
  ]
},

"attendance-counting":{
  category:"Education",
  pages:["dashboard","camera","report","analytics", "Attendance"],
  widgets:{
    dashboard:["live-count","entry-count","exit-count"],
    report:["trend-graph","attendance-table"],
    analytics:["hourly-activity-graph","zone-comparison-chart"]
  },
  modules:[
    "student-counting",
    "teacher-entry-detection",
    "gate-entry-exit-logging"
  ]
},

"campus-safety":{
  category:"Education",
  pages:["dashboard","camera","alert","analytics","insights"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list","alert-severity-breakdown"],
    analytics:["incident-distribution","trend-graph"],
    insights:["ai-insights"]
  },
  modules:[
    "suspicious-activity-detection",
    "loitering-detection",
    "violence-detection"
  ]
},

"unauthorized-access":{
  category:"Education",
  pages:["dashboard","camera","alert","analytics"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list"],
    analytics:["zone-comparison-chart"]
  },
  modules:[
    "restricted-area-detection",
    "intruder-detection"
  ]
},

"event-crowd-monitoring":{
  category:"Education",
  pages:["dashboard","camera","analytics","alert"],
  widgets:{
    dashboard:["live-occupancy","crowd-density","peak-hour"],
    analytics:["trend-graph","zone-breakdown"],
    alert:["alert-list"]
  },
  modules:[
    "crowd-density-detection",
    "overcrowding-detection"
  ]
},

"vandalism-detection":{
  category:"Education",
  pages:["dashboard","camera","alert","report"],
  widgets:{
    dashboard:["total-alerts","risk-score"],
    alert:["alert-list"],
    report:["incident-table"]
  },
  modules:[
    "vandalism-detection",
    "abnormal-behavior-detection"
  ]
},

};